export enum RoleType {
  ADMIN = 'ADMIN',
  COLLABORATOR = 'COLAB',
  STUDENT = 'ALUMNO',
}
